import { Component } from '@angular/core';
import { IonicPage, ModalController, NavController, ToastController, NavParams, AlertController, ViewController} from 'ionic-angular';
import { RestProvider } from '../../providers/rest/rest';
import { HttpClient} from '@angular/common/http';
import { DataProvider } from '../../providers/data/data';

@IonicPage()
@Component({
  selector: 'page-InfoSearch',
  templateUrl: 'InfoSearch.html',
})

export class InfoSearchPage {
  private getPosts = [];
  private deletePost = [];

  constructor(public navCtrl: NavController,
    public navParams: NavParams,
    private modalCtrl: ModalController,
    public alertCtrl: AlertController,
    private rest: RestProvider,
    private data: DataProvider,
    private toastCtrl: ToastController,
    public httpClient: HttpClient,
    ) {
  }

  ionViewDidLoad() {
    document.getElementById('backmenu').style.display = 'block';
    document.getElementById('backFrom').innerText = '';
    this.data.currentTabName = 'Хайх';
    this.getPost();
    /*this.rest.addPost(this.data.userId, this.data.userName, this.desc, this.data.companyId, this.url).subscribe(res => {
      this.getPosts = res;
    });*/
  }

  window(post:any){
    window.open(post.post_url);
  }

  filterItems(event) {
    this.rest.getPosts(this.data.companyId).subscribe(res => {
      this.getPosts = res.posts;
      const val = event.target.value;
      if (val && val.trim() != '') {
        this.getPosts = this.getPosts.filter((item) => {
          return (item.title.toLowerCase().indexOf(val.toLowerCase()) > -1);
        })
      }
    });
  }

  getPost(){
    this.rest.getPosts(this.data.companyId).subscribe(res => {
      this.getPosts = res.posts;
    });
  }

  delete(post : any) {
    if(confirm('Та сонгосон мэдээллээ устгахдаа итгэлтэй байна уу?')) {
      this.rest.deletePost(post.id).subscribe(res => {
        this.deletePost = res;
        this.showToast('Таны сонгосон мэдээллийг амжилттай устгалаа.');
        this.getPost();
      });
    }
  }

  addInfo(post : any){
    let addJobs = this.modalCtrl.create(
      ModalAddInfoPage,
      { post: post },
      {
        showBackdrop: false,
        enableBackdropDismiss: true
      }
    );
    addJobs.present().catch(err => {
    });

    addJobs.onDidDismiss((data) => {
      if(data != null) {
        this.getPost();
      }
    });
  }

  showToast(str: any) {
    let toast = this.toastCtrl.create({
      message: str,
      position: 'middle',
      duration: 5000,
      cssClass: "toast-success"
    });
    toast.present();
  }

  showToast1(str: any) {
    let toast = this.toastCtrl.create({
      message: str,
      position: 'middle',
      duration: 5000,
      cssClass: "toast-unsuccess"
    });
    toast.present();
  }
}

@Component({
  template: `
  <ion-header text-center style="height: 50px; text-align: center; background-color: #84dac8;">
    <ion-title *ngIf="post == null">Мэдээлэл нэмэх</ion-title>
    <ion-title *ngIf="post != null">Мэдээлэл засах</ion-title>
  </ion-header>
  <ion-content text-center>
    <ion-grid>

      <ion-row>
        <ion-col col-sm-3 col-xl-3 col-md-3 col-lg-3>
        </ion-col>
        <ion-col text-center col-sm-6 col-xl-6 col-md-6 col-lg-6>
          <ion-item>
            <ion-label floating>Мэдээллийн гарчиг</ion-label>
            <ion-textarea [(ngModel)]="name"></ion-textarea>
          </ion-item>
        </ion-col>
        <ion-col col-sm-3 col-xl-3 col-md-3 col-lg-3>
        </ion-col>
      </ion-row>

      <ion-row>
        <ion-col col-sm-3 col-xl-3 col-md-3 col-lg-3>
        </ion-col>
        <ion-col text-center col-sm-6 col-xl-6 col-md-6 col-lg-6>
          <ion-item>
            <ion-label floating>URL</ion-label>
            <ion-textarea [(ngModel)]="url"></ion-textarea>
          </ion-item>
        </ion-col>
        <ion-col col-sm-3 col-xl-3 col-md-3 col-lg-3>
        </ion-col>
      </ion-row>

      <ion-row>
        <ion-col col-sm-3 col-xl-3 col-md-3 col-lg-3>
        </ion-col>
        <ion-col text-center col-sm-6 col-xl-6 col-md-6 col-lg-6>
          <input type="file" id="fileLoader" #fileLoader name="files" title="Load File" hidden/>
                <span *ngIf="uploadImage != null">
                  <img id="checkinImage" [src]="uploadImage" (load)="imageLoaded()" style="height: 120px; width:120px; border-radius:50%"/>
                </span>
                <span *ngIf="uploadImage == null">
                  <img id="checkinImage" src="assets/imgs/avatar.png" (load)="imageLoaded()" style="height: 120px; width:120px; border-radius:50%"/>
                </span>

                    <ion-col col-sm-6 col-xl-6 col-md-6 col-lg-6>
                      <button class="myButton" ion-button icon-left (click)="presentActionSheet(fileLoader)">
                                <ion-icon name="camera"></ion-icon>Зураг сонгох
                              </button>
                              </ion-col>
                    <ion-col col-sm-6 col-xl-6 col-md-6 col-lg-6>
                      <button class="myButton" ion-button icon-left (click)="removePic()" [disabled]="uploadImage === null">
                                <ion-icon name="trash"></ion-icon>Устгах
                              </button>
                    </ion-col>
        </ion-col>
        <ion-col col-sm-3 col-xl-3 col-md-3 col-lg-3>
        </ion-col>
      </ion-row>

      <ion-row>
        <ion-col col-sm-3 col-xl-3 col-md-3 col-lg-3>
        </ion-col>
        <ion-col text-center col-sm-6 col-xl-6 col-md-6 col-lg-6>
          <ion-item>
            <ion-label floating>Тайлбар</ion-label>
            <ion-textarea [(ngModel)]="desc"></ion-textarea>
          </ion-item>
        </ion-col>
        <ion-col col-sm-3 col-xl-3 col-md-3 col-lg-3>
        </ion-col>
      </ion-row>

      <ion-row>
        <ion-col col-sm-3 col-xl-3 col-md-3 col-lg-3>
        </ion-col>
        <ion-col text-center col-sm-3 col-xl-3 col-md-3 col-lg-3>
          <ion-item>
            <button class="myButton" (click)="addInfo()" *ngIf="post == null">Нэмэх</button>
            <button class="myButton" (click)="setInfo()" *ngIf="post != null">Засах</button>
          </ion-item>
        </ion-col><ion-col text-center col-sm-3 col-xl-3 col-md-3 col-lg-3>
          <ion-item>
            <button class="myButton" (click)="backto()">Буцах</button>
          </ion-item>
        </ion-col>
        <ion-col col-sm-3 col-xl-3 col-md-3 col-lg-3>
        </ion-col>
      </ion-row>
</ion-grid>
</ion-content>
  `
})

export class  ModalAddInfoPage {
  private name: any;
  private url: any;
  private desc: any;
  private post: any;
  private editPost = [];
  private addPost = [];
  private postId: any;
  processing:boolean;
  uploadImage: string;

  constructor(public navCtrl: NavController,
    public navParams: NavParams,
    public alertCtrl: AlertController,
    private rest: RestProvider,
    private data: DataProvider,
    public httpClient: HttpClient,
    private toastCtrl: ToastController,
    private viewCtrl: ViewController,)
  {
    this.post = this.navParams.get('post');
        if(this.post != null) {
          this.postId = this.post.id;
          this.name = this.post.title;
          this.url = this.post.post_url;
          this.desc = this.post.post_desc;
          this.uploadImage = this.post.image;
        }
  }

  presentActionSheet(fileLoader) {
    fileLoader.click();
    var that = this;
    fileLoader.onchange = function () {
      var file = fileLoader.files[0];
      var reader = new FileReader();
      reader.addEventListener("load", function () {
        that.processing = true;
        // let src = (HTMLElement as ElementRef) document.getElementById('checkinImage').src;
        that.getOrientation(fileLoader.files[0], function (orientation) {
          if (orientation > 1) {
            that.resetOrientation(reader.result, orientation, function (resetBase64Image) {
              that.uploadImage = resetBase64Image;
            });
          } else {
            //that.uploadImage = reader.result;
            that.uploadImage = reader.result.toString();
          }
        });
      }, false);

      if (file) {
        reader.readAsDataURL(file);
      }
    }
  }

imageLoaded(){
  this.processing = false;
}

getOrientation(file, callback) {
  var reader = new FileReader();
  reader.onload = function (e:any) {

    var view = new DataView(e.target.result);
    if (view.getUint16(0, false) != 0xFFD8) return callback(-2);
    var length = view.byteLength, offset = 2;
    while (offset < length) {
      var marker = view.getUint16(offset, false);
      offset += 2;
      if (marker == 0xFFE1) {
        if (view.getUint32(offset += 2, false) != 0x45786966) return callback(-1);
        var little = view.getUint16(offset += 6, false) == 0x4949;
        offset += view.getUint32(offset + 4, little);
        var tags = view.getUint16(offset, little);
        offset += 2;
        for (var i = 0; i < tags; i++)
          if (view.getUint16(offset + (i * 12), little) == 0x0112)
            return callback(view.getUint16(offset + (i * 12) + 8, little));
      }
      else if ((marker & 0xFF00) != 0xFF00) break;
      else offset += view.getUint16(offset, false);
    }
    return callback(-1);
  };
  reader.readAsArrayBuffer(file);
}

resetOrientation(srcBase64, srcOrientation, callback) {
  var img = new Image();

  img.onload = function () {
    var width = img.width,
      height = img.height,
      canvas = document.createElement('canvas'),
      ctx = canvas.getContext("2d");

    // set proper canvas dimensions before transform & export
    if (4 < srcOrientation && srcOrientation < 9) {
      canvas.width = height;
      canvas.height = width;
    } else {
      canvas.width = width;
      canvas.height = height;
    }

    // transform context before drawing image
    switch (srcOrientation) {
      case 2: ctx.transform(-1, 0, 0, 1, width, 0); break;
      case 3: ctx.transform(-1, 0, 0, -1, width, height); break;
      case 4: ctx.transform(1, 0, 0, -1, 0, height); break;
      case 5: ctx.transform(0, 1, 1, 0, 0, 0); break;
      case 6: ctx.transform(0, 1, -1, 0, height, 0); break;
      case 7: ctx.transform(0, -1, -1, 0, height, width); break;
      case 8: ctx.transform(0, -1, 1, 0, 0, width); break;
      default: break;
    }

    // draw image
    ctx.drawImage(img, 0, 0);

    // export base64
    callback(canvas.toDataURL());
  };

  img.src = srcBase64;
}

removePic() {
  this.uploadImage = null;
}

  backto(){
    this.viewCtrl.dismiss({});
  }

  addInfo() {
    if( !this.name ){
      this.name == null;
      this.showToast1('Мэдээллийн нэр бичигдээгүй байна!!!');
      return;
    }
    if( !this.desc ){
      this.desc == null;
      this.showToast1('Тайлбар бичигдээгүй байна!!!');
      return;
    }
    this.rest.addPost(this.data.userId, this.name, this.desc, this.data.companyId, this.url, "").subscribe(res => {
      this.addPost = res;
      this.showToast('Таны сонгосон "Пост" амжилттай нэмэгдлээ.');
    });
    this.viewCtrl.dismiss({data: 'edit'});
  }

  setInfo() {
    if( !this.name ){
      this.name == null;
      this.showToast1('Мэдээллийн нэр бичигдээгүй байна!!!');
      return;
    }
    if( !this.desc ){
      this.desc == null;
      this.showToast1('Тайлбар бичигдээгүй байна!!!');
      return;
    }
    this.rest.editPost(this.data.userId, this.name, this.desc, this.postId, this.url, "").subscribe(res => {
      this.addPost = res;
      this.showToast('Таны сонгосон "Пост" амжилттай засагдлаа.');
    });
    this.viewCtrl.dismiss({data: 'edit'});
  }

  showToast(str: any) {
    let toast = this.toastCtrl.create({
      message: str,
      position: 'middle',
      duration: 5000,
      cssClass: "toast-success"
    });
    toast.present();
  }

  showToast1(str: any) {
    let toast = this.toastCtrl.create({
      message: str,
      position: 'middle',
      duration: 5000,
      cssClass: "toast-unsuccess"
    });
    toast.present();
  }

}



// WEBPACK FOOTER //
// ./src/pages/InfoSearch/InfoSearch.ts